import { chef } from '../../../../../index';
import classNames from '../../../../classNames';
import './styles';

const { templates: { titleSection: titleClassNames }} = classNames;
const getMainCls = (data = {}) => {
    const { cls, addCls, modCls, colorCls, alignCls, sizeCls, style, text } = data; 
    let mainCls = cls ? cls : `${titleClassNames.title}`;
    mainCls += ` ${modCls || ''} ${colorCls || ''} ${alignCls || ''} ${sizeCls || ''}`;
    return chef.useCookedStyles({ cls: mainCls, addCls, style, joint: true });
};

const titleSectionTpl = (initData = {}) => {
    const { text, align, color, size, other } = initData;
    const alignCls = { left: 'ck-align-left', center: 'ck-align-center', right: 'ck-align-right' }[align] || ''; /* Align left is default */
    const colorCls = chef.getClsNamesMap('colors')[color] || ''; /* Main color is default */
    const sizeCls = { s: 'ck-size-s', m: 'ck-size-m', l: 'ck-size-l', xl: 'ck-size-xl' }[size];
    const mainCls = getMainCls({...initData, colorCls, alignCls, sizeCls });
    
    return `<div ${mainCls}>
                <h2 class="${titleClassNames.text}">
                    ${text ? text : '...'}
                    <div class="ck-title-lines">
                        <div></div><div></div>
                        <!--<div></div><div></div>!-->
                    </div>
                  </h2>
              <div class="${titleClassNames.tools}" ></div>
          </div>`
}

const titleSectionModATpl = (initData = {}) => {   
    return titleSectionTpl({ ...initData, modCls: 'ck-mod-a'});
}

export { titleSectionTpl, titleSectionModATpl }